import { useContext } from 'react';

import { ModalNavigatorContext } from '../core/navigation/ModalNavigator';

export const useModalNavigator = () => useContext(ModalNavigatorContext);
